import React from 'react';
import './UIAvatarImage.scss';

const getGuaranteedAvatarUrl = (path?: string | null): string => {
  const localPlaceholder = '/ava/photo.png';

  if (!path) {
    return localPlaceholder;
  }

  // Якщо шлях вже є повним URL, повертаємо його як є.
  if (path.startsWith('http')) {
    return path;
  }

  // Якщо це наш локальний плейсхолдер, повертаємо його як є.
  if (path.startsWith('/ava/')) {
    return path;
  }

  // Для всіх інших шляхів (з бекенда) будуємо повний URL, уникаючи подвійних слешів.
  const backendUrl = `http://${process.env.REACT_APP_BACKEND_HOST}:${process.env.REACT_APP_BACKEND_PORT}`;
  const pathWithoutLeadingSlash = path.startsWith('/') ? path.substring(1) : path;
  
  return `${backendUrl}/${pathWithoutLeadingSlash}`;
};

export interface UIAvatarImageProps {
  avatar?: string | null;
  alt?: string;
  size?: 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge';
  className?: string;
  onClick?: () => void;
}

const baseClass = 'UIAvatarImage';

const UIAvatarImage: React.FC<UIAvatarImageProps> = ({
                                                       avatar,
                                                       alt = 'User avatar',
                                                       size = 'medium',
                                                       className = '',
                                                       onClick,
                                                     }) => {
  const containerClasses = [
    baseClass,
    `${baseClass}--${size}`,
    onClick && `${baseClass}--clickable`,
    className,
  ].filter(Boolean).join(' ');

  const imageUrl = getGuaranteedAvatarUrl(avatar);

  return (
    <div className={containerClasses} onClick={onClick}>
      <img
        src={imageUrl}
        alt={alt}
        className={`${baseClass}__image`}
      />
    </div>
  );
};

export default UIAvatarImage;
